<template>
  <div class="popup-main">
    <el-dialog
      width="420px"
      :title="selfData.id ? '编辑地址' : '新增地址'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <el-form ref="refForm" :model="selfData" :rules="rules" label-width="100px">
        <el-form-item label="姓名:" prop="link_man">
          <el-input v-model="selfData.link_man" size="mini" />
        </el-form-item>
        <el-form-item label="手机:" prop="link_phone">
          <el-input v-model="selfData.link_phone" size="mini" />
        </el-form-item>
        <el-form-item label="收货地址:" prop="address">
          <el-input v-model="selfData.address" size="mini" />
        </el-form-item>
        <el-form-item label="公司:" prop="company_name">
          <el-input v-model="selfData.company_name" size="mini" />
        </el-form-item>
        <el-form-item label="标签:" prop="tag">
          <el-input v-model="selfData.tag" size="mini" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      rules: {
        link_man: [{ required: true, message: '请输入姓名' }],
        link_phone: [{ required: true, message: '请输入手机' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
  },
  methods: {
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/address/saveOrUpdate',
            data: this.selfData
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch(() => {})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
